import EquipmentService from '_services/rest/modules/equipment';

export default {
  state: {
    equipment: null,
    equipmentList: null,
    equipmentCategories: null,
  },
  mutations: {
    setEquipment(state, response) {
      state.equipment = response;
    },
    setEquipmentList(state, response) {
      state.equipmentList = response;
    },
    setEquipmentCategories(state, response) {
      state.equipmentCategories = response;
    },
  },
  actions: {
    getEquipment({ commit }, params) {
      return EquipmentService.getEquipmentById(params)
        .then(response => {
          commit('setEquipment', response);
        });
    },
    getEquipmentList({ commit }, params) {
      return EquipmentService.getList(params)
        .then(response => {
          commit('setEquipmentList', response);
        });
    },
    getEquipmentCategories({ commit }) {
      return EquipmentService.getCategories()
        .then(response => {
          commit('setEquipmentCategories', response);
        });
    },
    saveEquipmentCategory(category) {
      return EquipmentService.saveCategory(category)
        .then(response => response);
    },
    deleteEquipmentCategory(id) {
      return EquipmentService.deleteCategory(id)
        .then(response => response);
    },
  },
};
